import { Button, ConfigProvider, Table, Tooltip } from "antd";
import { EyeFilled } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { ViewHistoryComments } from "../modals/ViewHistoryComments";
import TableEmptyContent from "../TableEmptyContent/TableEmptyContent";
import { columnsArr } from "./HistoryTableUtils";

const HistoryTable = ({
  listData,
  selectedColumns,
  page,
  pageSize,
  totalRecords,
  getHistoryDataFun,
}) => {
  const [dataSource, setDataSource] = useState([]);
  const [columns, setColumns] = useState([]);
  const [openComment, setOpenComment] = useState(false);
  const [selectedComments, setSelectedComments] = useState([]);
  const [commentSpec, setCommentSpec] = useState("");

  useEffect(() => {
    let arr = listData.map((ele, index) => {
      ele.key = `${index + 1}`;
      return ele;
    });
    setDataSource(arr);
  }, [listData]);

  const handleTableChange = (pagination) => {
    const { current, pageSize } = pagination;

    getHistoryDataFun(current, pageSize);
  };

  useEffect(() => {
    let arr = [];
    columnsArr.forEach((ele) => {
      if (selectedColumns.includes(ele.dataIndex) === true) {
        arr.push(ele);
      }
    });
    setColumns(arr);
  }, [selectedColumns]);

  const Row = ({ children, ...props }) => {
    return (
      <tr {...props} style={{ ...props.style }}>
        {React.Children.map(children, (child) => {
          let strDate = "";
          if (child.props?.record?.assigned_on) {
            strDate = new Date(child.props?.record?.assigned_on);
          }
          if (child.key === "spec_concat") {
            return React.cloneElement(child, {
              children: (
                <div>
                  <Tooltip title={child.props.record?.task_description}>
                    <span style={{ cursor: "pointer" }}>
                      {child.props.record?.spec_concat}
                    </span>
                  </Tooltip>
                </div>
              ),
            });
          }
          if (child.key === "comments") {
            return React.cloneElement(child, {
              children: child.props.record.comments ? (
                <ConfigProvider
                  theme={{
                    token: {
                      colorPrimary: "#EBEEF8",
                    },
                  }}
                >
                  <Button
                    onClick={() => {
                      setOpenComment(true);
                      setSelectedComments(child.props.record.comments);
                      setCommentSpec(child.props.record?.spec_concat);
                    }}
                    type="primary"
                    style={{ color: "#304CB2" }}
                    icon={<EyeFilled />}
                  >
                    View
                  </Button>
                </ConfigProvider>
              ) : (
                <span>-</span>
              ),
            });
          }
          if (child.key === "assigned_to") {
            return React.cloneElement(child, {
              children: (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: child.props.record.assigned_to
                      ? "space-between"
                      : "center",
                  }}
                >
                  {child.props.record.assigned_to ? (
                    `${child.props.record.assigned_to} - on  ${String(strDate).slice(4, 15)}`
                  ) : (
                    <span>-</span>
                  )}
                </div>
              ),
            });
          }
          return child;
        })}
      </tr>
    );
  };

  return (
    <div>
      <Table
        scroll={{ x: "max-content" }}
        components={{
          body: {
            row: Row,
          },
        }}
        rowKey="key"
        columns={columns}
        dataSource={dataSource}
        className="antdTable"
        locale={{
          emptyText: <TableEmptyContent />,
        }}
        pagination={{
          current: page,
          pageSize: pageSize,
          total: totalRecords,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ["10", "20", "50", "100"],
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
        }}
        onChange={handleTableChange}
      />
      <ViewHistoryComments
        open={openComment}
        setOpen={setOpenComment}
        messageData={selectedComments}
        commentSpec={commentSpec}
      />
    </div>
  );
};
export default HistoryTable;
